import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../css/EmployeeForms.css";
import { BASE_URL } from "../config";

const EmployeeHistory = () => {
  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [history, setHistory] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${BASE_URL}/api/states`)
      .then((res) => res.json())
      .then((data) => setStates(data))
      .catch((err) => console.error(err));
  }, []);

  useEffect(() => {
    if (selectedState) {
      fetch(`${BASE_URL}/api/employees?state_id=${selectedState}`)
        .then((res) => res.json())
        .then((data) => setEmployees(data))
        .catch((err) => console.error(err));
    }
  }, [selectedState]);

  useEffect(() => {
    if (selectedEmployee) {
      fetch(`${BASE_URL}/api/employee_history/${selectedEmployee.id}`)
        .then((res) => res.json())
        .then((data) => setHistory(data))
        .catch((err) => console.error(err));
    }
  }, [selectedEmployee]);

  const handleEmployeeSelect = (employee) => {
    setSelectedEmployee(employee);
  };

  return (
    <div className="employee-main-container">
      <Header />
      <Navbar />

      <div className="employee-content-container">
        <div className="employee-heading-container">
          <h2 className="employee-title">Employee History</h2>
        </div>

        <div className="employee-filter-container">
          <label htmlFor="stateSelect">State: </label>
          <select
            id="stateSelect"
            className="employee-state-dropdown"
            value={selectedState}
            onChange={(e) => setSelectedState(e.target.value)}
          >
            <option value="">Select State</option>
            {states.map((state) => (
              <option key={state.id} value={state.id}>
                {state.name}
              </option>
            ))}
          </select>
        </div>

        <div className="employee-table-container">
          <table className="employee-table">
            <thead className="text-white">
              <tr>
                <th>S.No</th>
                <th>ID</th>
                <th>Employee</th>
                <th>Division</th>
                <th>DOB</th>
                <th>DOJ</th>
                <th>Designation</th>
                <th>Mobile</th>
                <th>State</th>
                <th>HQ</th>
              </tr>
            </thead>
            <tbody>
              {employees.map((emp, index) => (
                <tr 
                  key={emp.id}
                  onClick={() => handleEmployeeSelect(emp)}
                  className={selectedEmployee?.id === emp.id ? "selected" : ""}
                >
                  <td>{index + 1}</td>
                  <td>{emp.id}</td>
                  <td>{emp.first_name} {emp.last_name}</td>
                  <td>{emp.division}</td>
                  <td>{emp.dob}</td>
                  <td>{emp.doj}</td>
                  <td>{emp.designation}</td>
                  <td>{emp.mobile}</td>
                  <td>{emp.state_name}</td>
                  <td>{emp.headquarter_name}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {selectedEmployee && (
          <div className="employee-details-form">
            <h3>Employment History for {selectedEmployee.first_name} {selectedEmployee.last_name}</h3>
            
            <div className="history-table-container">
              <table className="employee-table">
                <thead className="text-white">
                  <tr>
                    <th>Date</th>
                    <th>Event</th>
                    <th>Details</th>
                  </tr>
                </thead>
                <tbody>
                  {history.map((item, index) => (
                    <tr key={index}>
                      <td>{item.date}</td>
                      <td>{item.event}</td>
                      <td>{item.details}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="form-actions">
              <button 
                type="button" 
                className="cancel-btn"
                onClick={() => navigate(-1)}
              >
                Back
              </button>
            </div>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default EmployeeHistory;